import React from 'react';
import classnames from 'classnames';
import stylesheet from './Icons.scss';

// defaultClassName is used to override icon class, ie. facebook icon
export default function createIcon(svg, defaultClassName) {
  return ({ size = 'sm-b', className: additionalClassName, ...otherProps }) => {
    const classes = classnames([
      stylesheet.icon,
      { [stylesheet[`icon--${size}`]]: size },
      defaultClassName,
      additionalClassName,
    ]);

    return React.cloneElement(svg, {
      className: classes,
      ...otherProps,
    });
  };
}

export const ChevronRight100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M15.586 60.586a2 2 0 0 0 2.828 2.828l30-30a2 2 0 0 0 0-2.828l-30-30a2 2 0 0 0-2.828 2.828L44.172 32 15.586 60.586z"
    />
  </svg>
);

export const Actions100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M6 38a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm26 0a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm26 0a6 6 0 1 1 0-12 6 6 0 0 1 0 12z"
    />
  </svg>
);

export const Applied100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M30.876 58.05a7 7 0 0 1 2.998 0l7.327 1.607a4 4 0 0 0 4.224-1.75l3.455-5.394a12 12 0 0 1 3.633-3.633l5.394-3.455a4 4 0 0 0 1.75-4.224l-1.372-6.257a12 12 0 0 1 0-5.138l1.372-6.257a4 4 0 0 0-1.75-4.225l-5.394-3.454a12 12 0 0 1-3.633-3.633l-3.455-5.394a4 4 0 0 0-4.224-1.75l-6.257 1.372a12 12 0 0 1-5.138 0l-6.257-1.372a4 4 0 0 0-4.225 1.75l-3.454 5.394a12 12 0 0 1-3.633 3.633l-5.394 3.454a4 4 0 0 0-1.75 4.225l1.372 6.257a12 12 0 0 1 0 5.138l-1.372 6.257a4 4 0 0 0 1.75 4.224l5.394 3.455a12 12 0 0 1 3.633 3.633l3.454 5.394a4 4 0 0 0 4.225 1.75l7.327-1.606zm-6.47 5.514a8 8 0 0 1-8.45-3.5l-3.454-5.394a8 8 0 0 0-2.422-2.422l-5.394-3.454a8 8 0 0 1-3.5-8.45l1.371-6.256a8 8 0 0 0 0-3.426l-1.371-6.256a8 8 0 0 1 3.5-8.45l5.394-3.454a8 8 0 0 0 2.422-2.422l3.454-5.394a8 8 0 0 1 8.45-3.5l6.256 1.371a8 8 0 0 0 3.426 0l6.256-1.371a8 8 0 0 1 8.45 3.5l3.454 5.394a8 8 0 0 0 2.422 2.422l5.394 3.454a8 8 0 0 1 3.5 8.45l-1.371 6.256a8 8 0 0 0 0 3.426l1.371 6.256a8 8 0 0 1-3.5 8.45l-5.394 3.454a8 8 0 0 0-2.422 2.422l-3.454 5.394a8 8 0 0 1-8.45 3.5l-7.327-1.606a3 3 0 0 0-1.284 0l-7.327 1.606zM44.96 20.961a2 2 0 1 1 2.828 2.828l-20 20a2 2 0 0 1-2.828 0l-8-8a2 2 0 1 1 2.828-2.828l6.586 6.586L44.961 20.96z"
    />
  </svg>
);

export const ArrowDown100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.985 57.127V1.985a2 2 0 1 1 4 0v55.172L45.571 43.57A2 2 0 0 1 48.4 46.4L31.43 63.37a1.994 1.994 0 0 1-1.444.615c-.657 0-1.24-.317-1.605-.806L11.6 46.399a2 2 0 1 1 2.829-2.828l13.556 13.556z"
    />
  </svg>
);

export const ArrowLeft100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.858 32H62a2 2 0 1 0 0-4H6.828l13.586-13.586a2 2 0 0 0-2.828-2.828L.616 28.556A1.994 1.994 0 0 0 0 30c-.001.657.316 1.24.806 1.605l16.779 16.78a2 2 0 1 0 2.828-2.829L6.858 32z"
    />
  </svg>
);

export const ArrowRight100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M57.142 32H2a2 2 0 1 1 0-4h55.172L43.586 14.414a2 2 0 0 1 2.828-2.828l16.97 16.97.015.015a1.997 1.997 0 0 1-.206 3.034l-16.779 16.78a2 2 0 1 1-2.828-2.829L57.142 32z"
    />
  </svg>
);

export const ArrowUp100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.985 6.844v55.141a2 2 0 1 0 4 0V6.814l13.586 13.585a2 2 0 0 0 2.828-2.828L31.43.601a1.994 1.994 0 0 0-1.444-.615c-.657 0-1.24.316-1.605.806L11.6 17.572A2 2 0 1 0 14.43 20.4L27.985 6.844z"
    />
  </svg>
);

export const Bell100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M48.266 50l-1.927-2.89a2 2 0 0 1-.336-1.11V24c0-7.732-6.268-14-14-14s-14 6.268-14 14v22a2 2 0 0 1-.336 1.11L15.74 50h32.526zM29.003 6.249V3a3 3 0 0 1 6 0v3.249c8.514 1.428 15 8.832 15 17.751v21.394l3.664 5.497C54.554 52.22 53.601 54 52.003 54h-40c-1.597 0-2.55-1.78-1.664-3.11l3.664-5.496V24c0-8.919 6.487-16.323 15-17.751zm-3 51.751h12a6 6 0 1 1-12 0z"
    />
  </svg>
);

export const ChevronDown100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M60.586 15.586a2 2 0 0 1 2.828 2.828l-30 30a2 2 0 0 1-2.828 0l-30-30a2 2 0 0 1 2.828-2.828L32 44.172l28.586-28.586z"
    />
  </svg>
);

export const ChevronLeft100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M48.414 60.586a2 2 0 0 1-2.828 2.828l-30-30a2 2 0 0 1 0-2.828l30-30a2 2 0 0 1 2.828 2.828L19.828 32l28.586 28.586z"
    />
  </svg>
);

export const ChevronUp100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M60.586 48.414a2 2 0 0 0 2.828-2.828l-30-30a2 2 0 0 0-2.828 0l-30 30a2 2 0 0 0 2.828 2.828L32 19.828l28.586 28.586z"
    />
  </svg>
);

export const Close100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M32 29.172L3.414.586A2 2 0 1 0 .586 3.414L29.172 32 .586 60.586a2 2 0 0 0 2.828 2.828L32 34.828l28.586 28.586a2 2 0 0 0 2.828-2.828L34.828 32 63.414 3.414A2 2 0 0 0 60.586.586L32 29.172z"
    />
  </svg>
);

export const Invite100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M4 12v40h56V12H4zm0-4h56a4 4 0 0 1 4 4v40a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4zM2 28h60v4H2v-4zm18-18h4v44h-4V10zm-9.811 29.025l20.836-20.836c.885-.886 2.236-.97 3.017-.189.78.781.696 2.132-.189 3.017L13.017 41.853c-.885.885-2.236.97-3.017.189-.781-.781-.697-2.132.189-3.017z"
    />
  </svg>
);

export const Search100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M42.326 39.498l21.009 21.008a2 2 0 1 1-2.829 2.829L39.498 42.326A23.904 23.904 0 0 1 24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24a23.904 23.904 0 0 1-5.674 15.498zM24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z"
    />
  </svg>
);

export const StarFull = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M32 50.898L15.585 63.439c-1.242.95-2.984.665-3.89-.635a3.027 3.027 0 0 1-.397-2.625l6.322-20.217-16.467-13.4c-1.246-.943-1.526-2.765-.625-4.069a2.747 2.747 0 0 1 2.262-1.206l20.323.046L29.35 2.021C29.822.489 31.391-.353 32.855.14c.852.288 1.52.987 1.795 1.88l6.237 19.312 20.323-.046c1.537-.004 2.787 1.298 2.79 2.908a2.96 2.96 0 0 1-1.153 2.367l-16.467 13.4 6.322 20.217c.479 1.53-.318 3.175-1.78 3.676a2.682 2.682 0 0 1-2.507-.416L32 50.898z"
    />
  </svg>
);

export const StarEmpty100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M60.433 23.373a1.223 1.223 0 0 0-.034.027l.034-.027zM33.157 3.25l-.007.022a.83.83 0 0 0 .007-.022zM3.567 23.373l.035.027a1.248 1.248 0 0 0-.035-.027zm34.411 1.967l-.897-2.777-5.08-15.732-5.979 18.509-20.09-.046 16.314 13.275-6.059 19.376L32 45.865l15.813 12.08-6.06-19.376L58.07 25.294l-20.09.046zM32 50.898L15.585 63.439c-1.242.95-2.984.665-3.89-.635a3.027 3.027 0 0 1-.397-2.625l6.322-20.217-16.467-13.4c-1.246-.943-1.526-2.765-.625-4.069a2.747 2.747 0 0 1 2.262-1.206l20.323.046L29.35 2.021C29.822.489 31.391-.353 32.855.14c.852.288 1.52.987 1.795 1.88l6.237 19.312 20.323-.046c1.537-.004 2.787 1.298 2.79 2.908a2.96 2.96 0 0 1-1.153 2.367l-16.467 13.4 6.322 20.217c.479 1.53-.318 3.175-1.78 3.676a2.682 2.682 0 0 1-2.507-.416L32 50.898z"
    />
  </svg>
);

export const StarHalf100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M37.978 25.34l-.897-2.777-5.08-15.732-5.979 18.509-20.09-.046 16.314 13.275-6.059 19.376L32 45.865l15.813 12.08-6.06-19.376L58.07 25.294l-20.09.046zM32 50.898L15.585 63.439c-1.242.95-2.984.665-3.89-.635a3.027 3.027 0 0 1-.397-2.625l6.322-20.217-16.467-13.4c-1.246-.943-1.526-2.765-.625-4.069a2.747 2.747 0 0 1 2.262-1.206l20.323.046L29.35 2.021C29.822.489 31.391-.353 32.855.14c.852.288 1.52.987 1.795 1.88l6.237 19.312 20.323-.046c1.537-.004 2.787 1.298 2.79 2.908a2.96 2.96 0 0 1-1.153 2.367l-16.467 13.4 6.322 20.217c.479 1.53-.318 3.175-1.78 3.676a2.682 2.682 0 0 1-2.507-.416L32 50.898zm0 0L15.585 63.44c-1.242.95-2.984.665-3.89-.635a3.027 3.027 0 0 1-.397-2.625l6.322-20.217-16.467-13.4c-1.246-.943-1.526-2.765-.625-4.069a2.747 2.747 0 0 1 2.262-1.206l20.323.046L29.35 2.021C29.73.786 30.824 0 32 0v50.898z"
    />
  </svg>
);

export const Tip100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.296 40.172c0-2.383.295-4.283.887-5.699.591-1.416 1.76-2.97 3.508-4.664 1.747-1.693 2.854-2.899 3.32-3.615.717-1.094 1.075-2.276 1.075-3.549 0-1.684-.417-2.97-1.25-3.857s-2.056-1.331-3.67-1.331c-1.54 0-2.782.435-3.722 1.304-.941.869-1.412 2.047-1.412 3.535H20.5c.036-3.172 1.116-5.681 3.24-7.527C25.862 12.923 28.671 12 32.166 12c3.602 0 6.41.914 8.427 2.742 2.016 1.828 3.024 4.382 3.024 7.661 0 2.921-1.362 5.798-4.086 8.63l-3.306 3.252c-1.183 1.344-1.792 3.306-1.828 5.887h-6.102zm-.457 8.36c0-1.057.331-1.913.994-2.567.663-.654 1.56-.981 2.689-.981 1.146 0 2.051.336 2.715 1.008.663.672.994 1.519.994 2.54 0 .986-.322 1.81-.968 2.473-.645.663-1.559.995-2.741.995-1.183 0-2.093-.332-2.729-.995-.636-.663-.954-1.487-.954-2.473zM32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28zm0 4C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32z"
    />
  </svg>
);

export const Verified100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M12 30.702a31.1 31.1 0 0 0 20 29.051 31.1 31.1 0 0 0 20-29.051V10.883L32 4.216l-20 6.667v19.819zM8 8l24-8 24 8v22.702A35.1 35.1 0 0 1 32 64 35.1 35.1 0 0 1 8 30.702V8zm13.414 18.586a2 2 0 0 0-2.828 2.828l8 8a2 2 0 0 0 2.828 0l16-16a2 2 0 0 0-2.828-2.828L28 33.172l-6.586-6.586z"
    />
  </svg>
);

export const View100 = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M32 16c-9.677 0-18.646 5.213-27.013 16C13.354 42.787 22.323 48 32 48c9.677 0 18.646-5.213 27.013-16C50.646 21.213 41.677 16 32 16zm0 36C20.218 52 9.551 45.333 0 32c9.551-13.333 20.218-20 32-20s22.449 6.667 32 20c-9.551 13.333-20.218 20-32 20zm14-21a2 2 0 1 1-4 0 4 4 0 1 0-4 4 2 2 0 1 1 0 4 8 8 0 1 1 8-8zm-8.5 18C27.835 49 20 41.165 20 31.5S27.835 14 37.5 14 55 21.835 55 31.5 47.165 49 37.5 49zm0-4C44.956 45 51 38.956 51 31.5S44.956 18 37.5 18 24 24.044 24 31.5 30.044 45 37.5 45z"
    />
  </svg>
);

export const Cloud = createIcon(
  <svg viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M20,21.05a17,17,0,0,1,32,7h0a12,12,0,0,1,0,24H12A12.5,12.5,0,0,1,8,27.83a8,8,0,0,1,12-6.78Z"
    />
    <polygon fill="none" />
  </svg>
);
